<script lang="ts">
    import { onMount } from "svelte";
    import { metaAds } from "./functions";
    import { metaAdsStore } from "./meta-ads.store";
    export let metaAdsPixelId: string;
    export let cookieConsent: boolean = false;
    let initialized = false;

    onMount(() => {
        if (cookieConsent) {
            init();
        }
    });

    $: cookieConsent && init();

    function init() {
        if (initialized) {
            return;
        }
        initialized = true;
        (function (f, b, e, v, n, t, s) {
            if (f.fbq) return;
            n = f.fbq = function () {
                n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
            };
            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = !0;
            n.version = "2.0";
            n.queue = [];
            t = b.createElement(e);
            t.async = !0;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
        })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");

        metaAds.init(metaAdsPixelId);

        return metaAdsStore.subscribe((queue) => {
            if (!window.fbq || !metaAdsPixelId) {
                // don't let the queue grow too big
                // Mutate in place. Keep 50, and let the init event stay.
                queue.splice(1, queue.length - 50);
                return;
            }
            let next = queue.length && queue.shift();

            while (next) {
                const { type, event, data } = next;
                window.fbq(type, event, data);
                next = queue.shift();
            }
        });
    }
</script>

<noscript
    ><img
        alt=""
        height="1"
        width="1"
        style="display:none"
        src="https://www.facebook.com/tr?id={metaAdsPixelId}&ev=PageView&noscript=1"
    /></noscript
>
